import React, { useState, useEffect } from "react";
import axios from "axios";

const AttendanceReportPage = ({ agentId, startDate, endDate }) => {
  const [attendance, setAttendance] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const [loading, setLoading] = useState(true);
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (agentId) {
      const accessToken = sessionStorage.getItem("access_token");

      if (agentId === "all") {
        axios
          .get(`${baseURL}/getAllAttendance`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          })
          .then((response) => setAttendance(response.data))
          .catch((error) =>
            console.error("Error fetching all attendance:", error)
          )
          .finally(() => setLoading(false));
      } else {
        axios
          .get(`${baseURL}/getAgentAttendance`, {
            headers: { Authorization: `Bearer ${accessToken}` },
            params: { agent_id: agentId },
          })
          .then((response) => setAttendance(response.data))
          .catch((error) =>
            console.error("Error fetching agent attendance:", error)
          )
          .finally(() => setLoading(false));
      }
    }
  }, [agentId]);

  useEffect(() => {
    if (attendance.length > 0) {
      // Filter by startDate and endDate (only if both are provided)
      let filtered = [...attendance];

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        filtered = attendance.filter((record) => {
          const recordDate = new Date(record.date1);
          return recordDate >= start && recordDate <= end;
        });
      }

      const grouped = {};
      filtered.forEach((record) => {
        const adminLabel = record.admin_name || "Unknown Admin";
        if (!grouped[adminLabel]) {
          grouped[adminLabel] = [];
        }
        grouped[adminLabel].push({
          date: record.date1,
          status: record.atten_status,
        });
      });

      setGroupedData(grouped);
    } else {
      setGroupedData({});
    }
  }, [attendance, startDate, endDate]);

  const getStatusLabel = (status) => {
    switch (status) {
      case "P":
        return "Present";
      case "A":
        return "Absent";
      case "PER":
        return "Permission";
      case "H":
        return "Half Day";
      default:
        return status;
    }
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "";
    const parts = dateString.split("-");
    if (parts.length !== 3) return dateString;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading…</p>
      </div>
    );
  }

  return (
    <div className="p-5 bg-gray-50">
      <div className="bg-gray-200 p-4 rounded-lg">
        <div className="text-center">
          <h1 className="text-base sm:text-lg font-semibold">
            Attendance Records
          </h1>
          <p className="mt-1 text-sm sm:text-base text-gray-600">
            {formatDisplayDate(startDate)} - {formatDisplayDate(endDate)}
          </p>
        </div>
      </div>

      {Object.keys(groupedData).length > 0 ? (
        Object.keys(groupedData).map((adminName, index) => (
          <div key={index} className="mt-8">
            <h2 className="text-xl font-bold text-center mb-4">{adminName}</h2>

            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 text-left">S.No</th>
                  <th className="py-2 px-4 text-left">Date</th>
                  <th className="py-2 px-4 text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {groupedData[adminName].map((record, idx) => {
                  const rowClass = idx % 2 === 0 ? "bg-white" : "bg-gray-100";
                  return (
                    <tr key={idx} className={rowClass}>
                      <td className="py-2 px-4">{idx + 1}</td>
                      <td className="py-2 px-4">
                        {formatDisplayDate(record.date)}
                      </td>
                      <td className="py-2 px-4">
                        {getStatusLabel(record.status)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ))
      ) : (
        <div className="flex justify-center items-center mt-10">
          <div className="text-lg font-semibold text-gray-500">
            No attendance records found.
          </div>
        </div>
      )}
    </div>
  );
};

export default AttendanceReportPage;
